import React from 'react';
import Navbar from './Components/NavBarComponent/Navbar';
import HomeComponent from './Components/HomeComponent/HomeComponent';
import Footer from './Components/FooterComponent/Footer';
import SignUp from './Components/FormsComponent/SignUp';
import SignIn from './Components/FormsComponent/SignIn';
import ForgotPassword from './Components/FormsComponent/ForgotPassword';
import EmailVerification from './Components/FormsComponent/EmailVerification';
import ResetPassword from './Components/FormsComponent/ResetPassword';
import Applications from './Components/HomeComponent/Applications';
import Projects from './Components/HomeComponent/Projects';
import AboutSection from './Components/HomeComponent/AboutSection';
import Contact from './Components/HomeComponent/Contact';
import { Routes, Route } from 'react-router-dom';
import './App.css';


function App() {
  return (
    <>
      <Navbar></Navbar>
      <div>
      <Routes>
        <Route path='/' element={<HomeComponent></HomeComponent>}></Route>
        <Route path='/Projects' element={<Projects></Projects>}></Route>
        <Route path='/About' element={<AboutSection></AboutSection>}></Route>
        <Route path='/Contact' element={<Contact></Contact>}></Route>
        <Route path='/SignUp' element={<SignUp></SignUp>}></Route>
        <Route path='/SignIn' element={<SignIn></SignIn>}></Route>     
        <Route path='/ForgotPassword' element={<ForgotPassword></ForgotPassword>}></Route>  
        <Route path='/EmailVerification' element={<EmailVerification></EmailVerification>}></Route>     
        <Route path='/ResetPassword' element={<ResetPassword></ResetPassword>}></Route>   
        <Route path='/categories/:id' element={<Applications></Applications>}></Route>   
      </Routes>
      <Footer></Footer> 
      </div>

      
    </>
  );
}

export default App;
